import React, { useState, useEffect } from "react";
import {
  Space,
  Row,
  Col,
  Switch,
  Form,
  Input,
  Button,
  message,
  Checkbox,
  Alert,
  Skeleton,
} from "antd";
import { gql, useMutation } from "@apollo/client";
import DeleteCard from "@general/deleteCard";
import moment from "moment-jalaali";
import DeactivateCard from "@general/deactivateCard";
import ActiveCard from "@general/activateCard";
function CardForm({ formData, onDoUpdateData, onDoCloseDrawer, id }) {
  const [form] = Form.useForm();
  const [error, setError] = useState(null);
  const [editable, setEditable] = useState(false);
  const [delivered, setDelivered] = useState(false);

  const UPDATECARD = gql`
    mutation updateCard($updateCardInput: UpdateCardInput!, $id: ID!) {
      updateCard(updateInput: $updateCardInput, id: $id)
    }
  `;

  const [runUpdateCard, updateCard] = useMutation(UPDATECARD, {
    onCompleted() {
      message.success("اطلاعات کارت بروزرسانی شد.");
      onDoUpdateData();
    },
    onError(err) {
      console.log("خطا: " + err.message);
      const errMsg = err?.graphQLErrors?.[0]?.message || err?.message;
      const isKnownError =
        typeof errMsg === "string" &&
        (errMsg.includes("این شماره کارت") ||
          errMsg.includes("این شناسه کارت") ||
          errMsg.includes("این کاربر دارای کارت فعال می باشد"));
      if (isKnownError) {
        message.error(errMsg);
      } else {
        message.error("مشکلی پیش آمده! کارت بروزرسانی نشد.");
      }
    },
  });

  useEffect(() => {
    form.setFieldsValue(formData);
  }, [formData]);

  const onDoUpdateCard = (updateCardInput) => {
    runUpdateCard({
      variables: !delivered
        ? {
            id,
            updateCardInput: {
              ...updateCardInput,
              cardStatus: "DELIVERING",
            },
          }
        : {
            id,
            updateCardInput: {
              ...updateCardInput,
              cardStatus: "DELIVERED",
              deliveredAt: Date.now(),
            },
          },
    });
  };
  if (!formData)
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );
  else
    return (
      <>
        <Row>
          <Space align>
            <p>ویرایش: </p>
            <Switch onChange={() => setEditable(!editable)} />
          </Space>
        </Row>
        <Form
          layout="vertical"
          onFinish={onDoUpdateCard}
          form={form}
          disabled={!editable}
        >
          <Row>
            <Col xs={24} md={12}>
              <Row></Row>
              <Row gutter={30}>
                <Col xs={24} sm={12}>
                  <Form.Item
                    name="cardIdentifier"
                    id="cardIdentifier"
                    label="شناسه کارت"
                    rules={[
                      {
                        required: true,
                        message: "لطفا شناسه کارت را وارد کنید!",
                      },
                    ]}
                    validateStatus={error && "error"}
                  >
                    <Input className="form-input" placeholder={"شناسه کارت"} />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    name="cardNo"
                    id="cardNo"
                    label="شماره کارت"
                    rules={[
                      {
                        required: true,
                        message: "لطفا شماره کارت را وارد کنید!",
                      },
                    ]}
                    validateStatus={error && "error"}
                  >
                    <Input className="form-input" placeholder={"شماره کارت"} />
                  </Form.Item>
                </Col>
              </Row>{" "}
              <Row>
                <Col span={24}>
                  <Form.Item
                    label="توضیحات"
                    name="description"
                    rules={[{ required: false }]}
                  >
                    <Input.TextArea rows={3} placeholder="توضیحات" />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            {formData?.cardStatus !== "DELIVERED" ? (
              <Space align>
                <Checkbox onChange={() => setDelivered(!delivered)}>
                  <p style={{ fontSize: "16px", fontWeight: 500 }}>
                    کارت تحویل داده شد.
                  </p>
                </Checkbox>
              </Space>
            ) : (
              <Alert
                message={`کارت کاربر در تاریخ ${moment(
                  formData?.deliveredAt
                ).format("jYYYY/jMM/jDD")} تحویل داده شد.`}
                type="success"
              />
            )}
          </Row>
          {formData?.deactivatedAt && (
            <Row style={{ margin: "20px 0" }}>
              <Alert
                message={`کارت کاربر در تاریخ ${moment(
                  formData?.deactivatedAt
                ).format("jYYYY/jMM/jDD")} غیرفعال شده است.`}
                type="warning"
              />
            </Row>
          )}
          <Space style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={updateCard.loading && true}
            >
              بروزرسانی
            </Button>
            {formData?.deactivatedAt ? (
              <ActiveCard
              id={id}
              name={formData?.name}
              onActivateCard={onDoUpdateData}>
                <Button danger type="secondary">
                  فعال کردن کارت
                </Button>
              </ActiveCard>
            ) : (
              <DeactivateCard
                id={id}
                name={formData?.name}
                onDeactivateCard={onDoUpdateData}
              >
                <Button danger type="secondary">
                  غیرفعال کردن کارت
                </Button>
              </DeactivateCard>
            )}
            <DeleteCard
              id={id}
              name={formData?.name}
              onDeleteCard={onDoUpdateData}
              closeDrawer={onDoCloseDrawer}
            >
              <Button danger type="text">
                حذف کارت
              </Button>
            </DeleteCard>
          </Space>
        </Form>
      </>
    );
}

export default CardForm;
